import { OrderDetailV2Contact } from "./components/OrderDetailV2Contact";
import { OrderDetailV2ForInsurance } from "./components/OrderDetailV2ForInsurance";
import { OrderDetailV2Nominee } from "./components/OrderDetailV2Nominee";
import { OrderDetailV2OrderData } from "./components/OrderDetailV2OrderData";
import { OrderDetailV2PaymentInfo } from "./components/OrderDetailV2PaymentInfo";
import { OrderDetailV2PolicyDownload } from "./components/OrderDetailV2PolicyDownload";
import { OrderDetailV2PriceBreakup } from "./components/OrderDetailV2PriceBreakup";
import { OrderDetailV2Travellers } from "./components/OrderDetailV2Travellers";

export const ORDER_DETAIL_V2_COMPONENT_MAPPER = {
  left: {
    COMPONENT_ORDER_DETAILS_PAGE_ORDER_DATA: OrderDetailV2OrderData,
    COMPONENT_ORDER_DETAILS_PAGE_ENTITY_DETAIL: OrderDetailV2Travellers,
    COMPONENT_ORDER_DETAILS_PAGE_NOMINEE_DETAIL: OrderDetailV2Nominee,
    COMPONENT_ORDER_DETAILS_PAGE_CONTACT_DETAIL: OrderDetailV2Contact,
  },
  right: {
    COMPONENT_ORDER_DETAILS_PAGE_POLICY_DOWNLOAD: OrderDetailV2PolicyDownload,
    COMPONENT_ORDER_DETAILS_PAGE_ORDER_ACTIONS: OrderDetailV2ForInsurance,
    COMPONENT_ORDER_DETAILS_PAGE_PRICE_BREAKUP: OrderDetailV2PriceBreakup,
    COMPONENT_ORDER_DETAILS_PAGE_PAYMENT_INFO: OrderDetailV2PaymentInfo,
  },
} as const;
